import styled from 'styled-components';

import { Button } from '@atom/button/button';

export const CardWrapper = styled.div`
  display: grid;
  //grid-template-columns: repeat(2, 1fr);
  //grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 24px;
`;

export const PlanTypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  padding: 16px;
`;

export const PlanTypeButton = styled(Button)`
  width: 200px;
`;
